import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '../../../i18n';
import UrlTo from '../../../url-to';
import { userIcon } from '../../assets';
import './styles.scss';

const GuestDesktopNavbar = () => {
  return (
    <div className="courses-header__guest-wrapper courses-header__guest-wrapper_desktop">
      <Link to={UrlTo.login({ role: 'Rider', returnUrl: UrlTo.coursesHome() })}>
        <img src={userIcon} alt="Login" className='courses-header__login-icon' />
        {t('DIGITAL_COURSES.HEADER.LOGIN')}
      </Link>
    </div>
  );
};

export default GuestDesktopNavbar;
